import { Check } from "lucide-react"
import React from "react"
import PropTypes from "prop-types"

/**
 * Componente Checkbox padronizado da aplicação.
 *
 * @param {Object} props - Propriedades do componente
 * @param {boolean} props.multiplos - Define o formato do checkbox:
 *   - `false` (padrão): Checkbox redondo para seleção única (radio-like)
 *   - `true`: Checkbox quadrado para seleção múltipla
 * @param {boolean} props.checked - Estado de seleção do checkbox
 *
 * @example
 * // Seleção única (redondo)
 * <Checkbox multiplos={false} checked={isSelected} />
 *
 * // Seleção múltipla (quadrado)
 * <Checkbox multiplos={true} checked={isSelected} />
 */
const Checkbox = ({ multiplos = false, checked = false }) => {
  return (
    <div
      style={{
        border: checked ? "" : "solid 1px ",
        height: 21.5,
        width: 21.5,
        minWidth: 21.5,
        minHeight: 21.5,
        borderRadius: multiplos ? "20%" : "100%",
        flexShrink: 0,
      }}
    >
      {checked && (
        <div
          style={{
            backgroundColor: "#009FFD",
            height: "100%",
            width: "100%",
            borderRadius: multiplos ? "20%" : "100%",
            alignItems: "center",
            color: "white",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Check size={15} />
        </div>
      )}
    </div>
  )
}

Checkbox.propTypes = {
  multiplos: PropTypes.bool,
  checked: PropTypes.bool,
}

export default Checkbox
